import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { Layout } from "@/components/Layout";
import { businessSchema } from "@/components/SEO";
import HomePage from "@/pages/HomePage";
import { ServicesHubPage, ServiceDetailPage } from "@/pages/ServicePages";
import { ServiceAreasHubPage, ServiceAreaDetailPage } from "@/pages/ServiceAreaPages";
import { MaterialsHubPage, MaterialDetailPage } from "@/pages/MaterialsPages";
import { ServiceLocationPage, NotFoundPage, ThankYouPage } from "@/pages/ServiceLocationPages";
import { RoofCostCalculatorPage } from "@/pages/RoofCostCalculatorPage";
import { FreeRoofInspectionPage } from "@/pages/FreeRoofInspectionPage";
import RoofDesignerPage from "@/pages/RoofDesignerPage";
import MaciejPage from "@/pages/MaciejPage";
import { AboutPage, OurWorkPage, ReviewsPage, BlogHubPage, BlogPostPage, FAQPage, FinancingPage, LegalPage } from "@/pages/MiscPages";
import { ContactPage, EstimateWizardPage } from "@/pages/FormPages";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <html lang="en" />
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#C2410C" />
        <script type="application/ld+json">{JSON.stringify(businessSchema)}</script>
      </Helmet>
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesHubPage />} />
            <Route path="/services/:service/in/:city" element={<ServiceLocationPage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/service-areas" element={<ServiceAreasHubPage />} />
            <Route path="/service-areas/:slug" element={<ServiceAreaDetailPage />} />
            <Route path="/materials" element={<MaterialsHubPage />} />
            <Route path="/materials/:slug" element={<MaterialDetailPage />} />
            <Route path="/our-work" element={<OurWorkPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/about/maciej-ogonowski" element={<MaciejPage />} />
            <Route path="/blog" element={<BlogHubPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/get-estimate" element={<EstimateWizardPage />} />
            <Route path="/roof-cost-calculator" element={<RoofCostCalculatorPage />} />
            <Route path="/roof-designer" element={<RoofDesignerPage />} />
            {/* Legacy slug from the v1 release - keep a permanent SPA redirect for any indexed URL / shared link */}
            <Route path="/roof-visualizer" element={<Navigate to="/roof-designer" replace />} />
            <Route path="/free-roof-inspection" element={<FreeRoofInspectionPage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/financing" element={<FinancingPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/privacy-policy" element={<LegalPage type="privacy" />} />
            <Route path="/terms-of-service" element={<LegalPage type="terms" />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </HelmetProvider>
  );
}
